import { Modal } from 'react-bootstrap';
import './scss/RightModalLayout.scss';

const RightSideModal = ({ show, handleClose, modalBody }) => {
    return (
        <Modal show={show} onHide={handleClose} className="right fade" id="mainModal">
            <Modal.Body>
                <Modal.Header className="px-0">
                    <span className='common big' />
                    <button onClick={() => handleClose(true)}>
                        Close
                    </button>
                </Modal.Header>
                {modalBody}
                <Modal.Header className='finalTotal p-0'>
                    <span className='common subTotalLine' />
                    <button onClick={() => handleClose(true)}
                        className='subTotal'>
                        Sub Total
                    </button>
                </Modal.Header>
                <Modal.Header className='p-0 finalTotal'>
                    <span className='common finalLine ' />
                    <button onClick={() => handleClose(true)}
                        className=''>
                        ৳45000.00
                    </button>
                </Modal.Header>
                <span className='text-center d-block'><span className='text-danger'>Note:</span> Shipping will be calculated on checkout</span>
            </Modal.Body>
        </Modal>
    );
};

export default RightSideModal;